module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Light.ea4db2b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Light.woff2
// module id = L2wZ
// module chunks = 0